import React, { useCallback, useDeferredValue, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentUser, isAdmin } from 'store/modules/auth/selectors';
import { CrmDashboardTabs } from './CrmDashboardTabs';
import { DashboardHeader } from './DashboardHeader';
import { IUser } from 'services/BackendApi';
import { getDefaultMonthRange } from './helpers';

export const CrmDashboard: React.FC = () => {
  const userIsAdmin = useSelector(isAdmin);
  const currentUser = useSelector(getCurrentUser) as IUser;
  const [selectedSalesUser, setSelectedSalesUser] = useState<string | undefined>(undefined);

  const defaults = getDefaultMonthRange();
  const [dateFrom, setDateFrom] = useState<string>(defaults.monthFrom);
  const [dateTo, setDateTo] = useState<string>(defaults.monthTo);

  const deferredDateFrom = useDeferredValue(dateFrom);
  const deferredDateTo = useDeferredValue(dateTo);

  const handleDateFromChange = useCallback((nextDateFrom: string) => {
    setDateFrom(nextDateFrom);
  }, []);

  const handleDateToChange = useCallback((nextDateTo: string) => {
    setDateTo(nextDateTo);
  }, []);

  const handleSalesUserChange = useCallback((value?: string) => {
    setSelectedSalesUser(value);
  }, []);

  return (
    <div className="crm-dashboard mx-[20px] crm-desktop:mx-[80px]">
      <DashboardHeader
        isAdmin={userIsAdmin}
        currentUser={currentUser}
        salesUserId={selectedSalesUser}
        dateFrom={dateFrom}
        dateTo={dateTo}
        onSalesUserIdChange={handleSalesUserChange}
        onDateFromChange={handleDateFromChange}
        onDateToChange={handleDateToChange}
      />

      <div className="mt-[20px]">
        <CrmDashboardTabs salesUserId={selectedSalesUser} dateFrom={deferredDateFrom} dateTo={deferredDateTo} />
      </div>
    </div>
  );
};
